import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import Courses from 'containers/Administrator/Users/Profile/Teacher/Courses';
import Students from 'containers/Administrator/Users/Profile/Teacher/Students';

import { useTeacherCourseStore } from 'store/user/useTeacherCourseStore';

const Teacher = ({ setTab }) => {
	// Use teacher's course store
	const onReset = useTeacherCourseStore(state => state.onReset);

	// Reset teacher's courses on unmount
	useEffect(() => {
		return () => onReset();
	}, []);
	
	return (
		<Switch>
			{/* Teacher's courses */}
			<Route exact path="/users/:id(\d+)">
				<Courses tab="" setTab={setTab} />
			</Route>

			{/* Teacher's students */}
			<Route exact path="/users/students/:id(\d+)">
				<Students tab="students" setTab={setTab} />
			</Route>
		</Switch>
	);
};

export default Teacher;